import React from "react"
import Typography from "aldoo-ra/Typography"

const formatDate = (dateStr) => {
  if (!dateStr) return null
  const d = new Date(dateStr)
  if (isNaN(d.getTime())) return dateStr
  return d.toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  })
}

const timeAgo = (dateStr) => {
  if (!dateStr) return null
  const d = new Date(dateStr)
  if (isNaN(d.getTime())) return null
  const seconds = Math.floor((Date.now() - d.getTime()) / 1000)
  if (seconds < 60) return "just now"
  const minutes = Math.floor(seconds / 60)
  if (minutes < 60) return `${minutes}m ago`
  const hours = Math.floor(minutes / 60)
  if (hours < 24) return `${hours}h ago`
  const days = Math.floor(hours / 24)
  if (days < 30) return `${days}d ago`
  const months = Math.floor(days / 30)
  if (months < 12) return `${months}mo ago`
  return `${Math.floor(months / 12)}y ago`
}

const StatPill = ({ label, value, valueClass = "" }) => (
  <div className="flex items-center gap-1.5 bg-admin_canvas border border-admin_bordered rounded px-2.5 py-1.5">
    <span className="text-[10px] uppercase tracking-wider text-admin_text_secondary font-medium whitespace-nowrap">
      {label}
    </span>
    <span className={`text-xs font-semibold text-admin_text font-mono ${valueClass}`}>
      {value}
    </span>
  </div>
)

const AppDeploymentTab = ({ item }) => {
  const git = item.gitState || {}
  const local = git.localRevision || {}
  const remote = git.remoteRevision || {}
  const updates = git.updates || []
  const hasPending = git.status === "pending" && updates.length > 0
  const hasRemote = remote.hash && remote.hash !== local.hash

  return (
    <div className="space-y-4">
      {(local.date || local.author) && (
        <p className="text-sm text-admin_text_secondary">
          {local.date ? `Updated ${timeAgo(local.date)}` : ""}
          {local.author ? ` by ${local.author}` : ""}
        </p>
      )}

      <div className="flex flex-wrap gap-2">
        <StatPill label="Branch" value={git.branch || "main"} />
        {local.hash && (
          <StatPill label="Rev" value={local.hash.substring(0, 7)} />
        )}
        {local.date && (
          <StatPill label="Date" value={formatDate(local.date)} />
        )}
        {hasRemote && (
          <StatPill
            label="Remote"
            value={remote.hash.substring(0, 7)}
            valueClass="text-admin_warning"
          />
        )}
      </div>

      {local.subject && (
        <div className="space-y-1.5">
          <span className="text-[10px] uppercase tracking-wider text-admin_text_secondary font-medium">
            Commit Message
          </span>
          <div className="bg-admin_canvas border border-admin_bordered rounded p-3 max-h-40 overflow-y-auto">
            <p className="text-sm text-admin_text font-mono whitespace-pre-wrap break-words leading-relaxed">
              {local.subject}
            </p>
          </div>
        </div>
      )}

      {hasPending && (
        <div className="space-y-1.5">
          <span className="text-[10px] uppercase tracking-wider text-admin_text_secondary font-medium">
            Pending Commits
          </span>
          <div className="bg-admin_canvas border border-admin_bordered rounded divide-y divide-admin_bordered max-h-48 overflow-y-auto">
            {updates.slice(0, 10).map((update, i) => (
              <div key={i} className="flex items-start gap-3 px-3 py-2">
                <span className="text-xs font-mono text-admin_warning shrink-0 mt-0.5">
                  {update.hash?.substring(0, 7) || "—"}
                </span>
                <span className="text-xs text-admin_text_secondary leading-relaxed">
                  {update.subject || update.message || "—"}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export { timeAgo, formatDate }
export default AppDeploymentTab
